{
  "age": "Âge",
  "complianceState": "État de conformité",
  "dateOfBirth": "Date de naissance",
  "marketValue": "Valeur marchande",
  "createdAt": "Créé à",
  "state": "État",
  "accountType": "Type de compte",
  "goalType": "Type d'objectif",
  "jurisdiction": "Territoire",
  "user": "Clients",
  "account": "Comptes",
  "language": "Langue",
  "isOfficerOfPublicCompany": "Est un agent d'une entreprise publique",
  "isOwnerOfPublicCompany": "Est propriétaire d'une entreprise publique",
  "isMemberOfIiroc": "Est membre de l'OCRCVM",
  "politicallyExposedForeignPerson": "Est une personne étrangère politiquement exposée",
  "politicallyExposedDomesticPerson": "Est une personne locale politiquement exposée",
  "closeAssociateOfPEP": "Est un associé proche d'une PPE",
  "isAccreditedInvestor": "Est un investisseur accrédité",
  "powerOfAttorneyGranted": "Procuration accordée",
  "headOfInternationalOrganization": "Responsable d'une organisation internationale",
  "isVulnerablePerson": "Est une personne vulnérable",
  "isOwnerOfEntity": "Est propriétaire de l'entité",
  "amount": "Montant",
  "source": "Source",
  "type": "Type",
  "withdrawalReason": "Motif du retrait",
  "applyForGovFunds": "Demander des fonds publics",
  "countryOfTaxResidence": "Pays de résidence fiscale",
  "paysForeignTaxes": "Paie des impôts étrangers",
  "accountJurisdiction": "Territoire du compte",
  "advisorInterest": "Intérêt du conseiller",
  "investmentFirmTrade": "Transaction de société d'investissement",
  "useBorrowedMoney": "Utiliser de l'argent emprunté",
  "isReportingIssuer": "Est un émetteur assujetti",
  "tradingAuthorityOverAccountGranted": "Autorité de négociation sur le compte accordée"
}
